import mixpanel from "mixpanel-browser";

const mixpanelUtil = {
    sendEvent: (name, payload) => {
      if (window.location.href.includes('localhost')) return
        mixpanel.track(name, payload)
    },
}

export default mixpanelUtil